import React from "react";
import Lottie from "react-lottie";
import * as animationData from "./writelettersuccess.json"

export default class LottieControl extends React.Component {

  constructor(props) {
    super(props);
    this.state = {isStopped: false, isPaused: false};
  }

  render() {
    // const buttonStyle = {
    //   display: "block",
    //   margin: "10px auto"
    // };

    const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

    return <div>
       <Lottie options={defaultOptions}
              height={"100%"}
              width={277}
              isStopped={this.state.isStopped}
              isPaused={this.state.isPaused}/>
      <div style={{
        position: "absolute",
        width: "100%",
        height: "10%",
        top: 0,
        left: 0,
        backgroundColor: "#ffffff",
      }}></div>
     
    </div>
  }
}